<template>
  <div>
    <DocumentsAISummaryMessageFromAI
      :message-date="requestDate"
      :isSummaryRequestPending="false"
      shouldDisplayErrorMessage
    >
      <span class="font-weight-bold">
        {{ $t('project.documents.ai-summary.DocumentsAISummaryPdfWithNoTextWarning.unableToPerformOcr') }}
      </span>
      - {{ $t('project.documents.ai-summary.DocumentsAISummaryRequestChatMessage.errors.noCredits') }}
    </DocumentsAISummaryMessageFromAI>
  </div>
</template>

<script lang="ts">
import dayjs from "dayjs"
import { defineComponent } from 'vue'

import DocumentsAISummaryMessageFromAI from "@/project/documents/ai-summary/DocumentsAISummaryMessageFromAI.vue"

export default defineComponent({
  name: 'DocumentsAISummaryOcrProcess',
  components: {
    DocumentsAISummaryMessageFromAI,
  },
  data() {
    return {
      requestDate: dayjs().toISOString(),
    }
  },
})
</script>
